module.exports = __webpack_public_path__ + "images/7e24040c922202bcb4de2d51486b4f9936b5bd9d2b54abadcfc08c0c0e8e3cb4.svg";